"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NotFoundPage", {
  enumerable: true,
  get: function get() {
    return _NotFound.NotFound;
  }
});
var _NotFound = require("./NotFound");